import { css } from "@emotion/core";

export const styles = {
  wrapper: css`
    padding-left: 0;
    padding-right: 0;

    margin-top: 60px;
    background: transparent;
    display: flex;
    color: var(--color-anchor-dark);

    > section {
      flex: 1;
      text-align: center;
      justify-content: center;
      flex-direction: column;
      span {
        font-size: 0.75rem;
      }
      > * {
        margin: 0 0 0.65rem 0;
      }
    }
  `,
  instagramIcon: (isMobile: boolean) => css`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 3rem;
    height: 3rem;
    color: var(--color-anchor-dark);
    position: relative;
    > a {
      ${isMobile ? "position: fixed; bottom: .5rem; right: 1rem;" : ""}
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      :hover {
        transform: scale(1.2);
      }
    }
  `,
};
